import React from 'react';
import { useTranslation } from 'react-i18next';
import { helperMargin, Typography } from '@utex/ui-kit';
import { InstrumentCommission } from '../../types/instrument';
import { Commission } from '../Commission';
import { Money } from '../MoneyView';
import { Net } from './Net';

interface Props {
  amount: Money;
  commission: InstrumentCommission | null;
  isReverse: boolean;
  caption: string;
}

export const CommissionNote: React.FC<Props> = ({ caption, amount, commission, isReverse }) => {
  const { t } = useTranslation('withdraw');

  if (!commission) {
    return null;
  }

  return (
    <Typography.Paragraph
      size="M"
      view="hint"
      css={helperMargin({ left: { tablesktop: 15 }, bottom: { phonablet: 10 } })}
    >
      {caption}
      {': '}
      {commission.__typename === 'ClearingWithdrawPercentFee' && (
        <Net amount={amount} percentFee={commission.percent} isReverse={isReverse} />
      )}
      {commission.__typename === 'ClearingWithdrawFixedFee' && (
        <Net amount={amount} fixedFee={commission.amount} />
      )}
      <br />
      {t('Payment system fee is')} <Commission commission={commission} />
    </Typography.Paragraph>
  );
};
